/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { Modal } from '@components/molecules'
import { HomeSideNav, Footer } from '@components/systems'

import { useNavigate } from 'react-router-dom'
import { useAppDispatch, customerAuthActions } from '@redux/index'
import { grey, pink } from '@mui/material/colors'
import config from '@configs'
import { HomeNavMenuType } from '@redux/types'

const CustomerLogoutPage = () => {
	const navigate = useNavigate()

	// redux dispatch
	const reduxDispatch = useAppDispatch()

	const menuList: HomeNavMenuType[] = config.customerMenu()

	return (
		<View css={style}>
			<View className="outerView">
				<HomeSideNav menu={menuList} selectedIndes={3} />
				<View className="contentOuterView"></View>
			</View>

			<Footer />

			<Modal
				target="newGroup"
				title="Log out?"
				show={true}
				onCloseModal={() => navigate(-1)}
				onSubmit={() => {
					reduxDispatch(customerAuthActions.TRIGGER_LOGOUT(true))
				}}
				closeStatus="inherit"
				closeTitle="Keep stay"
				submitTitle="Log out"
				submitStatus="error"
				submitIconColor={pink['A400']}
			>
				<View css={{ width: '30rem' }}>
					<Text category="p2">Are you sure you want to log out?</Text>
				</View>
			</Modal>
		</View>
	)
}

export default CustomerLogoutPage

const style = css({
	position: 'relative',
	width: '100%',

	'.outerView': {
		display: 'flex',
		paddingTop: '2rem',
		paddingBottom: '2rem',
		borderBottom: '1px solid',
		borderColor: grey[300],
	},
})
